import { render, staticRenderFns } from "./PurchaseDuoKinds.vue?vue&type=template&id=5d94d464&"
import script from "./PurchaseDuoKinds.vue?vue&type=script&lang=js&"
export * from "./PurchaseDuoKinds.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports